<template>
    <div class="mainpage">
        <div class="def-settings col-lg-8 col-md-12 col-sm-12 mb-3">
            <p class="fw-bold">Default Settings</p>
            <div class="d-flex align-items-center col-12 mb-2">
                <div class="col-lg-8 col-md-8 col-sm-8">
                    <p class="mb-0">Select default domain to shorten for dynamic links</p>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3">
                    <Dropdown @change="checkChanged" class="def-dropdown" optionLabel="Domain" optionValue="Domain" v-model="defaultShortUrl" :options="getActiveDomains" />
                </div>
            </div>
            <div class="d-flex align-items-center col-12 mb-2">
                <div class="col-lg-8 col-md-8 col-sm-8">
                    <p class="mb-0">Select default short link length after /</p>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3">
                    <Dropdown @change="checkChanged" class="def-dropdown" v-model="defaultLength" :options="lengths" />
                </div>
            </div>
            <div class="d-flex align-items-center col-12 mb-2">
                <div class="col-lg-8 col-md-8 col-sm-8">
                    <p class="mb-0">Select default URL protocol</p>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3">
                    <Dropdown @change="checkChanged" class="def-dropdown" v-model="defaultProtocol" :options="urlProtocols" optionLabel="label" optionValue="value" />
                </div>
            </div>
        </div>
        <div class="actions-btns">
            <div class="gap">
                <Button class="mr-3" :disabled="this.isDisabled" label="Update" @click="updateSettings"/>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapModels } from '@/utils'
import { urlProtocols, lengths } from '@/constants'

export default {
    name: 'AccountSettings',
    components: {
    },
    data () {
        return {
            urlProtocols: urlProtocols,
            lengths: lengths
        }
    },
    methods: {
        async updateSettings () {
            const data = {
                default_domain: this.defaultShortUrl,
                default_length: this.defaultLength,
                default_protocol: this.defaultProtocol
            }
            this.globalLoader = true
            await this.$store.dispatch('Settings/Accounts/updateDefaultSetting', data)
            this.globalLoader = false
        },
        checkChanged () {
            if ((this.defaultShortUrl === this.getBeforeUpdate.defaultShortUrl) && (this.defaultProtocol === this.getBeforeUpdate.defaultProtocol) && (this.defaultLength === this.getBeforeUpdate.defaultLength)) {
                this.isDisabled = true
            } else {
                this.isDisabled = false
            }
        }
    },
    computed: {
        ...mapModels('general', ['globalLoader']),
        ...mapModels('Settings/Accounts', ['defaultShortUrl', 'defaultProtocol', 'defaultLength', 'isDisabled']),
        ...mapGetters({ currentUser: 'currentUser' }),
        ...mapGetters('Domains/Domain', ['getActiveDomains']),
        ...mapGetters('Settings/Accounts', ['getBeforeUpdate'])
    },
    async mounted () {
        this.$store.dispatch('Domains/Domain/fetchActiveDomains')
        await this.$store.dispatch('Settings/Accounts/fecthDefaultSettings')
    }
}
</script>

<style>
.def-settings {
    background-color: white;
    padding: 1rem;
}
.def-dropdown {
    width: 100%;
}
</style>
